module.exports = __webpack_public_path__ + "public/img/home_main2_img2@1x.9edb6fad.png";